<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="姓名" prop="name">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.name"
          placeholder="请输入姓名"
        />
      </Form-item>
      <Form-item label="手机号" prop="phoneNumber">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.phoneNumber"
          placeholder="请输入手机号"
        />
      </Form-item>
      <Form-item label="微信用户" prop="wxUserId">
        <c-wx-user-select
          class="c-form__input"
          :value="cForm.model.wxUserId"
          @change="
            value => {
              $set(cForm.model, 'wxUserId', value);
            }
          "
        >
        </c-wx-user-select>
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "@/mixins/form";

const module = "users";

@Component({
  mixins: [FormMixin]
})
export default class UsersListForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          name: [
            {
              required: true,
              message: "姓名不能为空"
            }
          ],
          phoneNumber: [
            {
              required: true,
              message: "手机号不能为空"
            },
            {
              pattern: /^1[3-9]\d{9}$/,
              message: "手机号格式错误"
            }
          ]
        }
      }
    };
  }

  getFormInitModel() {
    return {};
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;

        await this.$store.dispatch(`${module}/${id ? "put" : "post"}`, {
          id,
          body: model
        });

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list");
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
